import { render, staticRenderFns } from "./BaseReadOnlyField.vue?vue&type=template&id=1834d052"
import script from "./BaseReadOnlyField.vue?vue&type=script&lang=js"
export * from "./BaseReadOnlyField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/Companion.WebApp/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1834d052')) {
      api.createRecord('1834d052', component.options)
    } else {
      api.reload('1834d052', component.options)
    }
    module.hot.accept("./BaseReadOnlyField.vue?vue&type=template&id=1834d052", function () {
      api.rerender('1834d052', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/display-fields/BaseReadOnlyField.vue"
export default component.exports